import type { FaireProductEntity } from "../../entity_types/product";

export const p_2g5pfjjwkj: FaireProductEntity = {
  token: "p_2g5pfjjwkj",
  type: "product",
  name: "Lambswool Triangle Scarf",
  brandToken: "b_ciw03kwuu3",
  brandName: "Catherine Tough (US Duties Paid)",
  imageUrl:
    "https://cdn.faire.com/fastly/85a76c85a113e0ea3f6539f914c3d091582e6b32a8171ec257bfc7ba04a2857e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c70aa009999ef38b1348ba97f5b5d7d49435f0a4cbaebb440b3a8c8e842f045c.jpeg",
    "https://cdn.faire.com/fastly/961103061475a6793d40698a2f454206155ebe610447283f06f15801fdead92d.jpeg",
    "https://cdn.faire.com/fastly/7b43a9573574750dcef02df339e2394357d0fc2dcbc9e26d38a7b19080137f1a.jpeg",
    "https://cdn.faire.com/fastly/5350ec254327bdd1c6f4bbf1d70e44fee1fe6b7f0418cad9198db2704d4febab.jpeg",
    "https://cdn.faire.com/fastly/9d13b4c3b488dae7af369017b514b5b05a801d1706276e6def73bd734ac066ae.jpeg",
    "https://cdn.faire.com/fastly/b5865e705cf30e0f624b51fdf0f2884eb346df54da0810e276f4e4a71e4ad9eb.jpeg",
    "https://cdn.faire.com/fastly/10a249860ea0670855f3b257319cbe30b6863b34b332ce2373718a1e0312ef4f.jpeg",
  ],
  priceDollars: 38,
  description:
    "DUTY UPDATE\nOur USA pricing now includes prepaid duties for shipments sent via Royal Mail/USPS, with an estimated delivery time of 7-10 business days. There will be no additional fees upon receipt of your order. \n\nIf you would like your goods shipped via UPS, please inform us when placing your order. We can apply a discount for this option, but you will be responsible for all duties and brokerage fees.\n\nBeautifully soft neckerchief made from 100% lambswool, expertly knitted by a family-run studio in Portugal.\n\nPRODUCT DETAILS\nKnitted and then gently felted to create a naturally warm and durable fabric.\nSuper soft 100% merino lambswool\nBrighten up your winter wardrobe, look great and enjoy the cosy feeling of natural fibres.\nLayer up with our coordinating hats and gloves\n.\nSize: 40 x 100 cm\n\nHand wash at a temperature no higher than 30°C using a gentle wool detergent and fabric conditioner. Spin, dry flat, and steam iron to finish. It can also be dry-cleaned.\n",
  tags: [],
  msrpDollars: 76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:37.519Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
